import { SetMsgFeeProposalFormState } from "js/models"
import store from "js/store"
import { escapeHtmlGo } from "js/utils"
import { fieldTypes } from "../Helpers/types"
import { DecCoin } from 'carbon-js-sdk/lib/codec/cosmos/base/v1beta1/coin'
import { CarbonTx } from "carbon-js-sdk"
import { MsgSubmitProposal } from "carbon-js-sdk/lib/codec/cosmos/gov/v1/tx"
import { MsgSetGasCost } from "carbon-js-sdk/lib/codec/Switcheo/carbon/fee/tx"

export const setMsgFeeFormRequiredFields = ['msgType', 'gasCost']

export function setMsgFeeConfig() {
  return {
    msgType: {
      id: 'msgType',
      label: 'Message Type',
      type: fieldTypes.text,
      placeholder: 'Enter Message Type',
    },
    gasCost: {
      id: 'gasCost',
      label: 'Gas cost',
      tooltip: 'Gas cost',
      type: fieldTypes.number,
      constraints: {
        greaterThanOrEqualTo: 0,
      },
    },
  }
}

export function setMsgFeeProposalValue(proposer: string | undefined, initialDeposit: DecCoin[], authority: string): MsgSubmitProposal {
  const formState = store.getState().governance.submitProposalFormState as SetMsgFeeProposalFormState

  const { title, summary, metadata, msgType, gasCost } = formState!
  const setMsgFeeParams = {
    msgType: msgType,
    gasCost: gasCost,
  }

  const msg = MsgSetGasCost.fromPartial({
    creator: authority,
    setGasCostParams: setMsgFeeParams,
  })

  const value = {
    title: escapeHtmlGo(title),
    summary: escapeHtmlGo(summary),
    metadata: escapeHtmlGo(metadata),
    initialDeposit,
    expedited: false,
    proposer: proposer ?? "",
    messages: [
      {
        typeUrl: CarbonTx.Types.MsgSetGasCost,
        value: MsgSetGasCost.encode(msg).finish()
      }
    ],
  }

  return value
}
